export default __webpack_public_path__ + "static/media/admin-panel.16f0a39a.svg";